export default __webpack_public_path__ + "static/media/check.24a6e35d.svg";